export default __webpack_public_path__ + "static/media/Rectangle 40.0f998870.svg";